// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1igiY","left":"styles_left__1Hszj"};